import cn from 'classnames';
import type { MessageImagePayload } from 'models';
import { Flex, Image, Text } from 'ui';
import { useGetMediaSource } from 'features/media';

type P = {
  height?: string;
  hidden?: boolean;
  image: MessageImagePayload;
  overlayCount?: number;
  width?: string;
};

const ChatMessageBubbleImageItem = ({ height = '100%', hidden = false, image, overlayCount, width = '100%' }: P) => {
  const getMediaSource = useGetMediaSource();

  return (
    <div
      className={cn('chat-message-bubble-image-item', {
        'chat-message-bubble-image-item--hidden': hidden,
        'chat-message-bubble-image-item--more': Boolean(overlayCount),
      })}
    >
      <Image
        alt={image.meta.name}
        height={height}
        objectFit="cover"
        preview={overlayCount ? { mask: null } : true}
        rootClassName="chat-message-bubble-image-item__image-root"
        src={getMediaSource({ id: image.ref })}
        width={width}
      />
      {overlayCount ? (
        <Flex align="center" className="chat-message-bubble-image-item__more" justify="center">
          <Text className="chat-message-bubble-image-item__more-count" type="light" weight="medium">
            +{overlayCount}
          </Text>
        </Flex>
      ) : null}
    </div>
  );
};

export default ChatMessageBubbleImageItem;
